import { Loader2 } from 'lucide-react';

interface GuidedPlanningLoadingOverlayProps {
  isLoading: boolean;
}

export function GuidedPlanningLoadingOverlay({ isLoading }: GuidedPlanningLoadingOverlayProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/50">
      <Loader2 className="text-primary size-8 animate-spin" />
    </div>
  );
}
